export const START_HOUR = 0;
export const END_HOUR = 24;
export const SLOT_MINUTES = 30;

export const calculateTopPercentage = (startTimeISO: string): number => {
  const date = new Date(startTimeISO);
  const minutes = date.getHours() * 60 + date.getMinutes();
  const offsetMins = minutes - (START_HOUR * 60);
  
  if (offsetMins < 0) return 0;
  
  const totalMins = (END_HOUR - START_HOUR) * 60;
  return (offsetMins / totalMins) * 100;
};

export const calculateHeightPercentage = (startTimeISO: string, endTimeISO: string): number => {
  const start = new Date(startTimeISO);
  const end = new Date(endTimeISO);
  
  const durationMins = (end.getTime() - start.getTime()) / (1000 * 60);
  const totalMins = (END_HOUR - START_HOUR) * 60;
  
  return (durationMins / totalMins) * 100;
};
